<template>
    <div class="min-h-[50vh] container p-4 mt-8">
        <div class="bg-white rounded-md shadow-37 p-4">
            <div>
                <UiComponentTypography variant="h2" class-name="text-center">
                    می‌توانید برای تایید صحت نماد روی آن کلیک کنید.
                </UiComponentTypography>
            </div>
            <ul class="flex items-center justify-center gap-4 mt-12">
                <li class="w-1/4">
                    <a
                        class="flex items-center justify-center"
                        referrerpolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=528450&Code=5YmzUhJKTgGULjAPR4YsDQEJXWwYML2P"
                    >
                        <img
                            referrerpolicy="origin"
                            src="https://trustseal.enamad.ir/logo.aspx?id=528450&Code=5YmzUhJKTgGULjAPR4YsDQEJXWwYML2P"
                            alt=""
                            style="cursor: pointer"
                            code="5YmzUhJKTgGULjAPR4YsDQEJXWwYML2P"
                    /></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
useSeoMeta({
    title: "نماد اعتماد الکترونیکی (اینماد) | نرس‌لند",
    description: "مشاهده و تاییدیه نماد اعتماد الکترونیکی (اینماد) و مجوزهای قانونی فروشگاه اینترنتی رستری قهوه نرس‌لند.",
    canonical: "https://northland-co.com/namad",
    robots: "index, follow",
});
</script>

<style></style>
